var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "reply"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_3312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    transform: "matrix(-1 0 0 1 16.3335 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "reply_2",
    d: "M3.66683 12.6668V10.0002C3.66683 9.44461 3.86127 8.97238 4.25016 8.5835C4.63905 8.19461 5.11127 8.00016 5.66683 8.00016H11.7835L9.3835 10.4002L10.3335 11.3335L14.3335 7.3335L10.3335 3.3335L9.3835 4.26683L11.7835 6.66683H5.66683C4.74461 6.66683 3.9585 6.99183 3.3085 7.64183C2.6585 8.29183 2.3335 9.07794 2.3335 10.0002V12.6668H3.66683Z",
    fill: "#7C8D7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.e25691acc6945a7fa8eb1e1a542f6b28.svg";
export { ForwardRef as ReactComponent };